module.exports = __webpack_public_path__ + "img/trans.628a7133.png";